import { render, staticRenderFns } from "./PreguntaPad.vue?vue&type=template&id=59aa988f&"
import script from "./PreguntaPad.vue?vue&type=script&lang=js&"
export * from "./PreguntaPad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports